import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DigitalSignatureService {

  constructor(private http: HttpClient) { }

  saveSignature(email: string): Observable<any> {
    const params = new HttpParams().set('email', email);
    return this.http.post<any>(`${environment.baseUrl}/signature/save`, null, { params });
  }

  getAliases(signatureId: string): Observable<string[]> {
    const params = new HttpParams().set('signatureId', signatureId);
    return this.http.get<string[]>(`${environment.baseUrl}/signature/get-aliases`, { params });
  }

  // Implementarea metodei pentru savePassword
  savePassword(signatureId: string, password: string): Observable<void> {
    const params = new HttpParams().set('signatureId', signatureId).set('password', password);
    return this.http.post<void>(`${environment.baseUrl}/signature/save-password`, null, { params });
  }

  // Implementarea metodei pentru updateAlias
  updateAlias(signatureId: string, alias: string): Observable<void> {
    const params = new HttpParams().set('signatureId', signatureId).set('alias', alias);
    return this.http.put<void>(`${environment.baseUrl}/signature/update-alias-used`, null, { params });
  }

  getCertificate(signatureId: string): Observable<string> {
    const params = new HttpParams().set('signatureId', signatureId);
    return this.http.get<string>(`${environment.baseUrl}/signature/get-certificate`, { params , responseType: 'text' as 'json'});
  }

  getSignedDocumentUUID(requestBody: any): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}/signature/rectangle/get-signed-document`, requestBody);
  }

  getDocumentThatWillBeSigned(documentUUID: string): Observable<ArrayBuffer> {
    const params = new HttpParams().set('documentUUID', documentUUID);
    return this.http.get(`${environment.baseUrl}/signature/get-document`, { params, responseType: 'arraybuffer' });
  }

}
